import React from 'react';
import { Outlet } from 'react-router';

import classNames from 'classnames';

interface ContentAreaProps {
  children?: React.ReactNode;
  className?: string;
}

export const ContentArea = React.memo<ContentAreaProps>(
  ({ children, className }) => {
    return (
      <main
        id='dashboard-scroll-area'
        className={classNames(
          'rounded-4 min-w-0 h-full flex-1 shrink-0 overflow-auto bg-(--fly-color-scheme-gray-1) p-fly-6 [scrollbar-color:var(--fly-color-scheme-gray-4)_transparent] [scrollbar-width:thin]',
          className
        )}
      >
        <Outlet />
        {children}
      </main>
    );
  }
);

ContentArea.displayName = 'ContentArea';
